//import { useState, useEffect } from 'react';
import useStateEnRango from './use-state-en-rango';

function useStatePosicionEnRango(x, y, minX, maxX, minY, maxY) {
  var _useStateEnRango = useStateEnRango(x, minX, maxX),
      xEnRango = _useStateEnRango[0],
      setXEnRango = _useStateEnRango[1];

  var _useStateEnRango2 = useStateEnRango(y, minY, maxY),
      yEnRango = _useStateEnRango2[0],
      setYEnRango = _useStateEnRango2[1];

  var posicion = {
    x: xEnRango,
    y: yEnRango
  };

  function setter(_ref) {
    var x = _ref.x,
        y = _ref.y;
    setXEnRango(x);
    setYEnRango(y);
  }

  return [posicion, setter];
}

export default useStatePosicionEnRango;